import React, {useEffect, useState, useMemo, useRef} from 'react';
import {useQuery} from 'react-query';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {useTranslation} from 'react-i18next';
// import {useGeolocation} from '@uidotdev/usehooks';
import 'leaflet/dist/leaflet.css';
import './app.css';
import {
	useTheme,
	Box,
	Tab,
	CircularProgress,
	Card,
	ButtonBase,
	CardContent,
	Typography,
	Divider,
	ToggleButtonGroup,
	ToggleButton, Button, styled, Alert, Snackbar
} from '@mui/material';
import {SnackbarProvider, VariantType, useSnackbar} from 'notistack';
import axios, {AxiosError} from 'axios';
import {TParking, TLatLng, MapContext, LiveFoundObject} from '@context/MapContext';
import {appConfig} from '@config';
import ParkingLotsMapIcon from '@icons/ParkingLotsMapIcon';
import ParkingLotsListIcon from '@icons/ParkingLotsListIcon';
import {TabList, TabContext, TabPanel} from '@mui/lab';
import MapComponent from '@components/parking/components/Map';
import SearchInput from '@components/search/SearchInput';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import * as GeometryUtil from 'leaflet-geometryutil';
import {Link} from 'react-router-dom';
// import MainLinearGradient from '@icons/MainLinearGradient';
// import LogoIcon from '@icons/LogoIcon';
// import LogoEmptyIcon from '@icons/LogoEmptyIcon';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import {useProjectContext} from '@context/ProjectContext';
import L from 'leaflet';
// import {useAnalytics} from 'use-analytics';
// import analytics from '@hooks/analytics';

const serverUrl = appConfig.parking.url;
const parkingKey = [
	{
		'key': 'all'
	},
	{
		'key': 'near_the_shrine'
	},
	{
		'key': 'near_me'
	},
	{
		'key': 'online_capacity'
	}
];
const zoom: number = 15;

interface ValidationError {
	message: string;
	errors: Record<string, string[]>;
}

function ParkingLotsTabsComponent(props: {
	children: any,
	parkingLotsTabFilterKey: any;
	handleParkingLotsTabChange: any
}) {
	const {parkingLotsTabFilterKey, handleParkingLotsTabChange, children} = props;
	const {t} = useTranslation();
	const parkingLotsTabs = [
		{
			'key': 'parking_lots_map',
			'icon': <ParkingLotsMapIcon className="ml-1" active={parkingLotsTabFilterKey === 'parking_lots_map'}/>
		},
		{
			'key': 'parking_lots_list',
			'icon': <ParkingLotsListIcon className="ml-1" active={parkingLotsTabFilterKey === 'parking_lots_list'}/>
		}
	];
	return (
		<Box sx={{width: '100%', typography: 'body1'}}>
			<TabContext value={parkingLotsTabFilterKey}>
				<Box sx={{borderBottom: 1, borderColor: 'divider'}}>
					<TabList
						variant="fullWidth"
						className="min-h-10 h-10"
						textColor="secondary"
						indicatorColor="secondary"
						onChange={handleParkingLotsTabChange} aria-label="lab API tabs example"
					>
						{
							parkingLotsTabs.map((parking, index) => {
								return (
									<Tab
										key={parking.key}
										value={parking.key}
										icon={parking.icon}
										iconPosition="start"
										label={t(`parking.${parking.key}`)}
										className="min-h-10 h-10"
									/>
								);
							})
						}
					</TabList>
				</Box>
				{children}
			</TabContext>
		</Box>
	);
}

const fetchParkingList = async () => {
	try {
		// const res = await fetch(`${serverUrl}/parking`);
		const parkingLots = await axios({
			url: `${serverUrl}/parking`,
			method: 'get',
			headers: {
				// 'application/json' is the modern content-type for JSON, but some
				// older servers may use 'text/json'.
				// See: http://bit.ly/text-json
				'content-type': 'text/json'
				// Authorization: `Bearer ${token}`
			}
			// data: {
			// 	'id': appConfig.parking.id
			// }
		}).then((result) => {
			if (Object.keys(result.data).length > 0) {
				Object.values(result.data).filter((parking: any) => {
					if (parking.id == '64') {
						parking['x'] = '59.4724681';
						parking['y'] = '36.2804465';
						return parking;
					}
				});
				return result.data;
			} else {
				return null;
			}
		});
		//TODO fix danesh parking lat,lng
		// parkingLots["35"]["x"]="59.4724681";
		// parkingLots["35"]["y"]="36.2804465";
		return parkingLots;
	} catch (err) {
		const error = err as AxiosError;
		// console.log(error.message)
		// console.log(error.response?.data)
		// if (axios.isAxiosError<ValidationError, Record<string, unknown>>(err)) {
		// 	console.log(err.status);
		// 	console.error(err.response);
		// 	// Do something with this error...
		// } else {
		// 	console.error(err);
		// }
		return [];
	}
};
const Parking = () => {
	const theme = useTheme();
	const {t} = useTranslation();
	const {enqueueSnackbar} = useSnackbar();
	// useCountRender();
	// const state = useGeolocation();
	// Analytics-----------------------------------
	// const {track} = useAnalytics();
	// -----------------------------------
	const parkingLotStore = localStorage.getItem('parkingLot');
	let parkingLotObjectStore: any = (typeof parkingLotStore !== undefined && parkingLotStore !== '' && parkingLotStore !== null) ? JSON.parse(parkingLotStore) : null;
	// -----------------------------------
	const {liveLocation, setLiveLocation, liveFound, setLiveFound} = useProjectContext();
	// -----------------------------------
	const [map, setMap] = useState<L.Map>();
	const imamRezaShrine: TParking = {
		'id': '0',
		'name': t('imam_reza_shrine.title'),
		'capacity': '-1',
		'onlineCapacity': '-1',
		'address': t('imam_reza_shrine.title'),
		'x': '59.6157',
		'y': '36.2884'
	};
	// -----------------------------------
	const shrinePosition = {
		lat: parseFloat(imamRezaShrine?.y),
		lng: parseFloat(imamRezaShrine?.x)
	};
	// -----------------------------------
	const [latLng, setLatLng] = useState<TLatLng>(shrinePosition);
	const [parkingLots, setParkingLots] = useState<TParking[]>([]);
	const [parkingLot, setParkingLot] = useState<TParking>(parkingLotObjectStore);
	const [parkingLotsError, setParkingLotsError] = useState<string>('');
	const [openSnack, setOpenSnack] = useState<boolean>(false);
	const [openErrorSnack, setOpenErrorSnack] = useState<boolean>(false);
	const handleParkingSuccess = (parkingCapacity: TParking[]) => {
		if (typeof parkingCapacity !== undefined && Object.keys(parkingCapacity).length > 0) {
			setParkingLots(() => parkingCapacity);
			setTimeout(() => {
				if (parkingLotObjectStore && Object.keys(parkingCapacity).length > 0) {
					let updateParkingLot = Object.values(parkingCapacity).filter((parking): boolean => {
						return parking.id == parkingLotObjectStore['id'];
					});
					setParkingLot(updateParkingLot[0]);
				}
			}, 100);
		}
	};
	const handleParkingError = (error: Error) => {
		setOpenErrorSnack(true);
		setParkingLotsError(error.message);
	};
	const {
		data,
		isFetching,
		isLoading,
		isFetched,
		isSuccess,
		status,
		error,
		refetch
	} = useQuery(
		'parking_list',
		fetchParkingList,
		{onSuccess: handleParkingSuccess, onError: handleParkingError, enabled: false}
	);
	// -----------------------------------
	const [counter, setCounter] = useState<number>(60);
	const [parkingLotsFilter, setParkingLotsFilter] = useState<TParking[]>([]);
	const [parkingFilterKey, setParkingFilterKey] = useState<string>('all');
	const [showParkingLots, setShowParkingLots] = useState<boolean>(false);
	const [dialogInfo, setDialogInfo] = useState<TParking>();
	const [search, setSearch] = useState('');
	const [parkingLotsTabFilterKey, setParkingLotsTabFilterKey] = useState<string>('parking_lots_map');
	// -----------------------------------
	useEffect(() => {
		const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
		return () => clearInterval(timer);
	}, [counter]);
	// -----------------------------------
	useEffect(() => {
		if (isFetched) {
			setParkingLotsFilter(Object.values(parkingLots));
		}
	}, [isFetching]);
	// -----------------------------------
	const txtSearch = useRef<HTMLInputElement>();
	const handleChangeSearchFiled = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(txtSearch.current!.value);
	};
	// -----------------------------------
	const handleGroupChange = useMemo(() => (
		event: React.MouseEvent<HTMLElement>,
		newValue: string) => {
		setParkingFilterKey(() => newValue);
	}, [parkingFilterKey]);
	// -----------------------------------
	// -----------------------------------
	const parkingAction = (parking: TParking) => {
		let parkingLat = parseFloat(parking?.y) || null;
		let parkingLng = parseFloat(parking?.x) || null;
		/*track('parking_view', {
			name: parking.name
		});*/
		// analytics.sendEvent({
		// 	label: 'parking_view',
		// 	action: 'action',
		// 	category: 'category',
		// 	value: parseFloat(parking.id) as number
		// });
		if (parkingLat && parkingLng) {
			setLatLng({
				lat: parseFloat(parking?.y),
				lng: parseFloat(parking?.x)
			});
			setParkingLot(parking);
			localStorage.setItem('parkingLot', JSON.stringify(parking));
			setShowParkingLots(false);
			setParkingLotsTabFilterKey(() => 'parking_lots_map');
		}
	};
	// -----------------------------------
	const handleParkingLotsTabChange = useMemo(() => (event: React.SyntheticEvent | null, newValue: string) => {
		setParkingLotsTabFilterKey(() => newValue);
	}, [parkingLotsTabFilterKey]);
	
	// Actions-----------------------------------
	function compare<T extends Object>(
		property: keyof T,
		sort_order: 'asc' | 'desc'
	) {
		const compareFn = (a: T, b: T) => {
			const valA = a[property];
			const valC = b[property];
			const order = sort_order !== 'desc' ? 1 : -1;
			switch (typeof valA) {
				case 'number': {
					const valB = valC as number;
					const result = valA - valB;
					return result * order;
				}
				case 'string': {
					const valB = valC as string;
					const result = valA.localeCompare(valB);
					return result * order;
				}
				// case 'boolean': {
				// 	const valB = valC as boolean;
				// 	return order === 1 ? (valA ? valA : valB) : (valB ? valB : valA);
				// }
				// add other cases like boolean, etc.
				default:
					return 0;
			}
		};
		return compareFn;
	}
	
	// function dynamicSort(property) {
	// 	var sortOrder = 1;
	// 	if(property[0] === "-") {
	// 		sortOrder = -1;
	// 		property = property.substr(1);
	// 	}
	// 	return function (a,b) {
	// 		/* next line works with strings and numbers,
	// 		 * and you may want to customize it to your needs
	// 		 */
	// 		var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
	// 		return result * sortOrder;
	// 	}
	// }
	// function dynamicSortMultiple() {
	// 	/*
	// 	 * save the arguments object as it will be overwritten
	// 	 * note that arguments object is an array-like object
	// 	 * consisting of the names of the properties to sort by
	// 	 */
	// 	var props = arguments;
	// 	return function (obj1, obj2) {
	// 		var i = 0, result = 0, numberOfProperties = props.length;
	// 		/* try getting a different result from 0 (equal)
	// 		 * as long as we have extra properties to compare
	// 		 */
	// 		while(result === 0 && i < numberOfProperties) {
	// 			result = dynamicSort(props[i])(obj1, obj2);
	// 			i++;
	// 		}
	// 		return result;
	// 	}
	// }
	
	// const compare = (a: TParking & { distance: number }, b: TParking & { distance: number }) => {
	// 	if (a.distance < b.distance) {
	// 		return -1;
	// 	}
	// 	if (a.distance > b.distance) {
	// 		return 1;
	// 	}
	// 	return 0;
	// };
	
	const filterByLatLngDistance = (location: number[], distance: number = 1000) => {
		// let layerPoint1 = getSlippyTileLayerPoints(36.2884, 59.6157, zoom);
		// let layerPoint1 = getSlippyTileLayerPoints(36.2884, 59.6157, zoom);
		let filteredCapacity: TParking[] = [];
		// let zoom = map?.getZoom();
		// @ts-ignore
		let point1 = map?.project(location, zoom).floor();
		Object.values(parkingLots).filter((parking) => {
			// @ts-ignore
			let point2 = map?.project([parking?.y, parking?.x], zoom).floor();
			// @ts-ignore
			let closest_latlng = GeometryUtil.length([point1, point2]);
			if (parseFloat(closest_latlng) < distance) {
				parking['distance'] = Math.round((parseFloat(closest_latlng + Number.EPSILON) * 100) / 100);
				filteredCapacity.push(parking);
			}
			// filteredCapacity = _.sortBy(filteredCapacity, 'distance');
			filteredCapacity.sort(compare('distance', 'asc'));
		});
		return filteredCapacity;
	};
	useEffect(() => {
		(async () => {
			// @ts-ignore
			// let closest_latlng = GeometryUtil.distance(map, [36.2884, 59.6157], [latLng.lat, latLng.lng]);
			// console.log(closest_latlng);
			let filteredCapacity: TParking[] = [];
			if (parkingFilterKey === 'all') {
				Object.values(parkingLots).filter((parking) => {
					delete parking.distance;
					filteredCapacity.push(parking);
				});
			}
			if (parkingFilterKey === 'near_the_shrine') {
				filteredCapacity = filterByLatLngDistance([parseFloat(imamRezaShrine.y as string), parseFloat(imamRezaShrine.x as string)]);
			}
			if (parkingFilterKey === 'near_me') {
				setOpenSnack(true);
				if (liveLocation) {
					setOpenSnack(false);
					filteredCapacity = filterByLatLngDistance([liveLocation.lat, liveLocation.lng]);
				} else {
					if (navigator.geolocation) {
						setLiveFound(LiveFoundObject.Locating);
						// get the current users location
						navigator.geolocation.getCurrentPosition(
							(position) => {
								// save the geolocation coordinates in two variables
								const {latitude, longitude} = position.coords;
								// update the value of userlocation variable
								setLiveFound(LiveFoundObject.Found);
								setLiveLocation({lat: latitude, lng: longitude});
								filteredCapacity = filterByLatLngDistance([latitude, longitude]);
								setParkingLotsFilter(filteredCapacity);
								setParkingFilterKey('near_me');
								setOpenSnack(false);
							},
							// if there was an error getting the users location
							(error) => {
								setLiveFound(LiveFoundObject.NotFound);
								setOpenSnack(false);
								// console.error('Error getting user location:', error);
							}
						);
					}
					// await showLiveLocation().then((res: TLatLng | any) => {
					// 	setLiveLocation(res);
					// 	filteredCapacity = filterByLatLngDistance([res?.lat, res?.lng]);
					// });
				}
			}
			if (parkingFilterKey === 'online_capacity') {
				Object.values(parkingLots).filter((parking) => {
					delete parking.distance;
					if (Number(parking.onlineCapacity) > 0) {
						filteredCapacity.push(parking);
					}
				});
				filteredCapacity.sort((a, b) => (parseFloat(a.onlineCapacity) > parseFloat(b.onlineCapacity)) ? -1 : ((parseFloat(b.onlineCapacity) < parseFloat(a.onlineCapacity)) ? 1 : 0));
			}
			if (setParkingLotsFilter) {
				setParkingLotsFilter(filteredCapacity);
			}
		})();
	}, [parkingFilterKey]);
	// -----------------------------------
	// -----------------------------------
	// -----------------------------------
	useEffect(() => {
		refetch().then(r => null);
	}, []);
	const parkingLotsFilterBySearch = (): TParking[] => {
		// if (search.length) {
		// let parkingLotsCount = Object.keys(parkingLotsFilter).length;
		let searchFilterFounded = parkingLotsFilter.filter(parking => {
			return search.length > 0 ? (parking.name.includes(search) || parking.address.includes(search)) : parking;
		});
		return searchFilterFounded;
		// }
		// return true;
	};
	return (
		<>
			{/*<SnackbarProvider>*/}
			<Snackbar
				open={openSnack}
				anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
				onClose={() => setOpenSnack(false)}
				// TransitionComponent={TransitionUp}
				// message={t(`parking.locating`)}
				className="flex justify-center text-center mb-10"
				ContentProps={{
					sx: {
						display: 'block',
						textAlign: 'center'
					}
				}}
			>
				<Alert onClose={() => setOpenSnack(false)} severity="info" sx={{width: '100%'}}>
					{t(`parking.locating`)}
				</Alert>
			</Snackbar>
			
			<Snackbar
				open={openErrorSnack}
				anchorOrigin={{vertical: 'top', horizontal: 'center'}}
				onClose={() => setOpenErrorSnack(false)}
				// TransitionComponent={TransitionUp}
				// message={t(`parking.locating`)}
				className="flex justify-center text-center mt-48"
				ContentProps={{
					sx: {
						display: 'block',
						textAlign: 'center'
					}
				}}
			>
				<Alert onClose={() => setOpenErrorSnack(false)} severity="error" sx={{width: '100%'}}>
					{t(`parking.shahrdari_server_error`)}
				</Alert>
			</Snackbar>
			{/*</SnackbarProvider>*/}
			
			<div id="parking" className="w-full h-full flex flex-col space-y-2">
				<HeaderWithIcons title={t('parking.parking_text')}/>
				<div className="h-full">
					{
						Object.keys(parkingLots).length > 0 ? (
							<ParkingLotsTabsComponent
								parkingLotsTabFilterKey={parkingLotsTabFilterKey}
								handleParkingLotsTabChange={handleParkingLotsTabChange}
							>
								<TabPanel value="parking_lots_map">
									<MapContext.Provider
										value={{
											refetch,
											map,
											setMap,
											zoom,
											imamRezaShrine,
											parkingLot,
											setParkingLot,
											parkingLots,
											setParkingLots,
											parkingLotsFilter,
											setParkingLotsFilter,
											parkingFilterKey,
											setParkingFilterKey,
											showParkingLots,
											setShowParkingLots,
											latLng,
											setLatLng,
											openSnack,
											setOpenSnack,
											counter,
											setCounter
										}}
									>
										<MapComponent/>
									</MapContext.Provider>
								</TabPanel>
								<TabPanel value="parking_lots_list" className="h-full">
									<div className="flex flex-col w-full space-y-3">
										<SearchInput
											placeholder={t('parking.search_parking_lots')}
											inputRef={txtSearch}
											onChange={handleChangeSearchFiled}
											className="px-3 pt-2"
											data={{
												'start': parkingLotsFilterBySearch().length
											}}
										/>
										<div className="px-3">
											<ToggleButtonGroup
												color="primary"
												value={parkingFilterKey}
												exclusive={true}
												onChange={handleGroupChange}
												aria-label="Platform"
												className="flex justify-between"
												// disabled={!liveFound}
											>
												{
													parkingKey.map((parking, index) => {
														return (
															<ToggleButton
																key={parking.key}
																value={parking.key}
																className="border-0 rounded"
																disabled={parking.key === parkingFilterKey}
															>
																{t(`parking.${parking.key}`)}
															</ToggleButton>
														);
													})
												}
											</ToggleButtonGroup>
										</div>
										{/*{liveFound != 0 ? (*/}
										{
											parkingLotsFilterBySearch().length > 0 ? (
												<SimpleBar
													forceVisible="y"
													autoHide={true}
													className="h-[calc(100vh-230px)] px-3"
												>
													<div className="space-y-2 w-full">
														{parkingLotsFilterBySearch().map((parking: any, index: number) => {
															return (
																<Card
																	key={index}
																	className={`border ${
																		parking.id == parkingLot?.id ? (parking.onlineCapacity > 10 ? 'bg-green-50' : parking.onlineCapacity > 0 ? 'bg-orange-50' : 'bg-red-50') : null} ${parking.onlineCapacity > 10 ? 'border-gray-200' : parking.onlineCapacity > 0 ? 'border-orange-200' : 'border-red-200'}`}
																	variant="outlined"
																>
																	<ButtonBase
																		onClick={() => parkingAction(parking)}
																		className="w-full"
																	>
																		<CardContent className="p-0 px-3 pt-3 w-full">
																			<div className="flex flex-row justify-between">
																				<Typography
																					gutterBottom
																					variant="h5"
																					component="div"
																					className="font-bold"
																					sx={{
																						color: (theme) => {
																							// @ts-ignore
																							return parking.onlineCapacity > 10 ? theme.palette.success[600] : parking.onlineCapacity > 0 ? theme.palette.warning[600] : theme.palette.error[600];
																						},
																						fontSize: (theme) => theme.typography.fontSize + 5
																					}}
																				>
																					{parking.name}
																				</Typography>
																				{
																					!parking?.y && !parking.x ? (
																						<Typography sx={{
																							fontSize: (theme) => theme.typography.fontSize - 3
																						}} className="text-red-600">
																							{t('parking.location_not_defined')}
																						</Typography>
																					) : null
																				}
																				{
																					parking.distance ? (
																						<div className="flex felx-row">
																							<Typography sx={{
																								color: (theme) => {
																									// @ts-ignore
																									return parking.distance < 800 ? 'gray.600' : theme.palette.warning[600];
																								},
																								fontSize: (theme) => theme.typography.fontSize + 2
																							}} className="mx-2">
																								{t('parking.distance')}<span
																								className="text-xs">({t('parking.meter')}): </span>
																							</Typography>
																							<Typography className="font-medium" sx={{
																								color: (theme) => {
																									// @ts-ignore
																									return parking.distance < 800 ? 'gray.600' : theme.palette.warning[600];
																								},
																								fontSize: (theme) => theme.typography.fontSize + 2
																							}}>
																								{parking.distance}
																							</Typography>
																						</div>
																					) : null
																				}
																			</div>
																			<div className="flex flex-row text-center justify-between items-center">
																				<div className="flex flex-row justify-between items-center">
																					{
																						parking.onlineCapacity > 0 ? (
																							<>
																								<Typography sx={{
																									color: (theme) => {
																										// @ts-ignore
																										return parking.onlineCapacity > 10 ? 'gray.600' : theme.palette.warning[600];
																									},
																									fontSize: (theme) => theme.typography.fontSize + 2
																								}} className="mx-2">
																									{t('parking.empty_capacity')}:
																								</Typography>
																								<Typography className="font-medium" sx={{
																									color: (theme) => {
																										// @ts-ignore
																										return parking.onlineCapacity > 10 ? 'gray.600' : theme.palette.warning[600];
																									},
																									fontSize: (theme) => theme.typography.fontSize + 2
																								}}>
																									{parking.onlineCapacity}
																								</Typography>
																							</>
																						) : (
																							<Typography sx={{
																								color: (theme) => {
																									// @ts-ignore
																									return theme.palette.mode === 'light' ? theme.palette.error[600] : theme.palette.error[600];
																								},
																								fontSize: (theme) => theme.typography.fontSize + 2
																							}} className="mx-2">
																								{t('parking.empty_capacity_text')}
																							</Typography>
																						)
																					}
																				</div>
																				<div className="flex flex-row justify-between items-center">
																					<Typography sx={{
																						color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
																						fontSize: (theme) => theme.typography.fontSize + 2
																					}} className="mx-2">
																						{t('parking.total_capacity')}:
																					</Typography>
																					<Typography className="font-medium" sx={{
																						color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
																						fontSize: (theme) => theme.typography.fontSize + 2
																					}}>
																						{parking.capacity}
																					</Typography>
																				</div>
																			</div>
																			<div className="w-full flex flex-row items-center justify-center my-2">
																				<Divider
																					className={`w-3/5 items-center ${parking.onlineCapacity > 10 ? 'bg-gray-200' : parking.onlineCapacity > 0 ? 'bg-yellow-200' : 'bg-red-200'}`}/>
																			</div>
																			<div className="flex flex-row justify-start items-center">
																				<Typography sx={{
																					color: (theme) => theme.palette.mode === 'light' ? 'grey.500' : 'grey.300',
																					fontSize: (theme) => theme.typography.fontSize + 2
																				}} className="mx-2">
																					{t('parking.address')}:
																				</Typography>
																				<Typography className="font-medium" sx={{
																					color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.200',
																					fontSize: (theme) => theme.typography.fontSize + 1
																				}}>
																					{parking.address}
																				</Typography>
																			</div>
																			{/*<div className="w-full h-32 block">*/}
																			{/*	<MapBox location={parking}/>*/}
																			{/*</div>*/}
																		</CardContent>
																		
																		{/*<CardActionArea>*/}
																		{/*	<CardMedia*/}
																		{/*		component="img"*/}
																		{/*		height="140"*/}
																		{/*		image="/static/images/cards/contemplative-reptile.jpg"*/}
																		{/*		alt="green iguana"*/}
																		{/*	/>*/}
																		{/*</CardActionArea>*/}
																		{/*<CardActions>*/}
																		{/*	/!*<Button size="small" color="primary">*!/*/}
																		{/*	/!*	{t('parking.directions_to_the_parking_lot')}*!/*/}
																		{/*	/!*</Button>*!/*/}
																		{/*	<Button size="small" color="primary" onClick={() => {*/}
																		{/*		setParingLot(parking);*/}
																		{/*		setShowParkingLots(false);*/}
																		{/*		setLatLng({*/}
																		{/*			lat: parseFloat(parking?.y),*/}
																		{/*			lng: parseFloat(parking?.x)*/}
																		{/*		});*/}
																		{/*	}}>*/}
																		{/*		{t('parking.show_on_map')}*/}
																		{/*	</Button>*/}
																		{/*</CardActions>*/}
																	</ButtonBase>
																	<div className="w-full flex justify-center mb-2">
																		{
																			liveFound === 1 &&
																			<Link
																				to={`/parking/route/live_parking/${[liveLocation?.lat, liveLocation?.lng]}/${[parseFloat(parking?.y as string), parseFloat(parking?.x as string)]}`}>
																				{/*<Button*/}
																				{/*	sx={{*/}
																				{/*		background: (theme) => 'linear-gradient(45deg, #0051de 50%, #638aff 100%)',*/}
																				{/*	}}*/}
																				{/*	size="small"*/}
																				{/*	color="primary"*/}
																				{/*	variant="contained"*/}
																				{/*>*/}
																				{/*	{t('parking.dir_to_parking')}*/}
																				{/*</Button>*/}
																				<Button
																					size="small"
																					className="border-0 bg-gradient-to-r from-[#0051de] to-[#638aff] text-white px-5 py-1 rounded-md"
																				>
																					{t('parking.dir_to_parking')}
																				</Button>
																			</Link>
																		}
																		{/*{*/}
																		{/*	liveFound === 1 &&*/}
																		{/*	<Link*/}
																		{/*		to={`/parking/route/live_shrine/${[liveLocation?.lat, liveLocation?.lng]}/${[parseFloat(imamRezaShrine?.y as string), parseFloat(imamRezaShrine?.x as string)]}`}>*/}
																		{/*		/!*<Button*!/*/}
																		{/*		/!*	sx={{*!/*/}
																		{/*		/!*		background: (theme) => 'linear-gradient(45deg, #0051de 50%, #638aff 100%)',*!/*/}
																		{/*		/!*	}}*!/*/}
																		{/*		/!*	size="small"*!/*/}
																		{/*		/!*	color="primary"*!/*/}
																		{/*		/!*	variant="contained"*!/*/}
																		{/*		/!*>*!/*/}
																		{/*		/!*	{t('parking.dir_to_parking')}*!/*/}
																		{/*		/!*</Button>*!/*/}
																		{/*		<GradientButton*/}
																		{/*			size="small"*/}
																		{/*			color="primary"*/}
																		{/*			variant="contained">*/}
																		{/*			{t('parking.dir_live_to_shrine')}*/}
																		{/*		</GradientButton>*/}
																		{/*	</Link>*/}
																		{/*}*/}
																	</div>
																</Card>
															);
														})}
													</div>
												</SimpleBar>
											) : (
												<div className="w-full h-full flex flex-col justify-center pt-20">
													<div className="w-full flex justify-center items-center">
														{/*<LogoEmptyIcon/>*/}
														<HourglassEmptyIcon/>
													</div>
													<div className="w-full text-center mt-5">{t('no_content_was_found')}</div>
												</div>
											)
											// ) : (
											// 	<>
											// 		<div className="w-full text-center mt-10">{t('parking.locating')}</div>
											// 		<div className="flex flex-row flex-1 w-full h-full justify-center items-center">
											// 			<CircularProgress color={'secondary'}/>
											// 		</div>
											// 	</>
											// )
										}
									</div>
								</TabPanel>
							</ParkingLotsTabsComponent>
						) : (
							<div className="flex flex-col flex-1 w-full h-full justify-center items-center">
								<Typography
									gutterBottom
									variant="h5"
									component="div"
									className="font-bold"
									sx={{
										fontSize: (theme) => theme.typography.fontSize + 3
									}}
								>
									{t('parking.loading_parking_info')}
								</Typography>
								<Button
									size="small"
									color="primary"
									variant="outlined"
									className={`${(isLoading || isFetching) ? 'hidden' : 'block'}`}
									onClick={() => refetch()}
								>
									{t('parking.reload')}
								</Button>
								{
									(isLoading || isFetching) && <CircularProgress color={'secondary'} className="mt-3"/>
								}
							</div>
						)
					}
					{/*{*/}
					{/*	(!isLoading && isSuccess) ? (*/}
					{/*		<></>*/}
					{/*	) : (*/}
					{/*		<div className="flex flex-row flex-1 w-full h-full justify-center items-center">*/}
					{/*			<CircularProgress color={'secondary'}/>*/}
					{/*		</div>*/}
					{/*	)*/}
					{/*}*/}
				</div>
			</div>
		</>
	);
};
export default Parking;
